import Image from "@/components/AppImage";
import business_commercial_Illu from "/public/img/business-commercial-Illu.png";

const BusinessAndCommercial = () => {
  return (
    <section className="business-commercial">
      <div className="overlay pt-120 pb-120">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 d-flex align-items-center">
              <div className="img-area">
                <Image src={business_commercial_Illu} alt="icon" />
              </div>
            </div>
            <div className="col-lg-6 d-flex align-items-center">
              <div className="section">
                <h2 className="title">Teams that pay collaborators in crypto</h2>
                <p>
                  Studios and collectives use OracleMarket to route USDC revenue to
                  contributors worldwide while finance keeps a unified audit
                  trail.
                </p>
                <p>
                  Combine fiat invoicing with on-chain settlements so tax,
                  payroll, and treasury partners always see the same numbers.
                </p>
                <p>
                  Delegate approvals, require dual sign-off on large sends, and
                  freeze wallets instantly if credentials are compromised.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BusinessAndCommercial;
